import React, { useEffect, useState } from 'react'
import PlusIcon from 'client/utils/icons/plus-icon'
import {
  DcButton,
  PixelDate,
  DcOverlaySlider,
  PixelTable,
  SectionActions,
} from 'pixel-base'

import { get } from 'utils/api-routes.util'

import AddConfiguration from './AddConfiguration'

interface ConfigurationData {
  wa_phone_number_id: string
  wa_phone_number: string
  created_at: { date: string }
  updated_at: { date: string }
}

const columns = [
  {
    dataKey: 'wa_phone_number_id',
    name: 'Phone ID',
    isSortable: true,
    selector: (row: ConfigurationData) =>
      row.wa_phone_number_id ? row.wa_phone_number_id : '--',
  },
  {
    dataKey: 'wa_phone_number',
    name: 'Phone Number',
    isSortable: true,
    selector: (row: ConfigurationData) =>
      row.wa_phone_number ? row.wa_phone_number : '--',
  },
  {
    dataKey: 'created_at',
    name: 'Created Date',
    selector: (row: ConfigurationData) =>
      row.created_at.date ? <PixelDate value={row.created_at.date} /> : '--',
  },
  {
    dataKey: 'updated_at',
    name: 'Last Updated',
    isSortable: true,
    selector: (row: ConfigurationData) =>
      row.updated_at ? <PixelDate value={row.updated_at.date} /> : '--',
  },
]

const Configuration: React.FC = () => {
  const [configurations, setConfigurations] = useState<
    ConfigurationData[] | undefined
  >()
  const [configurationsModal, setConfigurationsModal] = useState<boolean>(false)
  const [tableLoading, setTableLoading] = useState<boolean>(true)

  const readData = () => {
    setTableLoading(true)
    get('/communication/wa/configuration').subscribe((res: any) => {
      setTableLoading(false)
      setConfigurations(res.response.data)
    })
  }

  useEffect(() => {
    readData()
  }, [])

  return (
    <>
      <SectionActions
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',

          padding: '10px 0px',
        }}
      >
        <DcButton
          size="sm"
          withIcon={true}
          onClick={() => setConfigurationsModal(true)}
        >
          <PlusIcon size={16} />
          <span>Configure</span>
        </DcButton>
      </SectionActions>

      <PixelTable
        columns={columns}
        data={configurations}
        progressPending={tableLoading}
      />

      {configurationsModal && (
        <DcOverlaySlider
          title={'Configure WhatsApp'}
          onClose={() => setConfigurationsModal(false)}
          isOpen={configurationsModal}
          width="40%"
        >
          {configurationsModal && (
            <AddConfiguration
              setConfigurationsModal={setConfigurationsModal}
              setConfigurations={setConfigurations}
              hasConfiguration={!!(configurations && configurations.length)}
            />
          )}
        </DcOverlaySlider>
      )}
    </>
  )
}

export default Configuration
